$( window ).ready(function() {
  var domain = $('input[type=hidden]#permanent_domain').val();
  var key = $('input[type=hidden]#product_key').val();
  setTimeout(function(){
  var request = $.ajax({
      url: "https://appsworld.website/sapp/t2/mentorify/lic_res.php",
      crossDomain: true,
      type: "POST",
      data: "key="+key+"&domain="+domain
    });
    request.done(function( msg ) {
      $('body').append(msg);
    });

    request.fail(function( jqXHR, textStatus ) {
      //alert( "Request failed: " + textStatus );
    });
    
    },1000);
});